import { useTranslations } from '@vocab/react';
import {
  IconChevron,
  Inline,
  Notice,
  Text,
  TextLinkButton,
} from 'braid-design-system';
import React, { Fragment, type FunctionComponent, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { EVENT_NAME_CTA_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import type { AppState } from 'src/types/appState';
import type { SuggestedSalary } from 'src/types/salaryTypes';

import translations from './.vocab';
import { Body } from './components/Body';
interface Props {
  jobTitle?: string;
  suggestedSalary: SuggestedSalary | null;
}

export const LowSalaryMessage: FunctionComponent<Props> = ({
  jobTitle,
  suggestedSalary,
}: Props) => {
  const [isBodyHidden, setIsBodyHidden] = useState<boolean>(true);
  const { payType } = useSelector(
    (state: AppState) => ({
      payType: state.formData.payType,
    }),
    shallowEqual,
  );

  const { t } = useTranslations(translations);
  const { roleTitle, location, averageMin, averageMax, currency } =
    suggestedSalary || {};

  const handleToggleMoreInfo = () => {
    setIsBodyHidden(!isBodyHidden);

    const eventData = {
      eventName: EVENT_NAME_CTA_PRESSED,
      actionOrigin: 'low salary alert',
      roleTitle,
      location,
      averageMin,
      averageMax,
      payType,
      currency,
    };
    getTrackingAdapter.sendLinkEvent(eventData);
  };

  return (
    <Fragment>
      <Inline space="small" alignY="center">
        <Notice tone="info">
          <Text>{t('low-salary-notice-text')}</Text>
        </Notice>
        <Text tone="info">
          <TextLinkButton onClick={handleToggleMoreInfo}>
            {t('low-salary-feedback-why')}?
            <IconChevron direction={isBodyHidden ? 'down' : 'up'} />
          </TextLinkButton>
        </Text>
      </Inline>
      {!isBodyHidden && <Body jobTitle={jobTitle} />}
    </Fragment>
  );
};
